import React, { useRef } from 'react'
import InlineSVG from 'react-inlinesvg';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap'
import infoIcon from '../../assets/svg/link-new-tab.svg';

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const GenderV2Field = ({
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    lang,
    aria,
    placeholder,
    id,
    name,
    valid,
    hasError,
    field,
    data,

    labelInfo,
    _errorMessage,
}) => {
    const textRef = useRef(null);
    const hasOther = data?.externalState?.groupData?.patientInfoSettings?.canHaveOtherGender === true;

    // console.log('gendervalue: ', value);

    return (
        <>
            <legend className={`formV2-field-label ${labelInfo ? 'form-group-label-wrap' : ''} ${classes?.label}`}>
                {field?.config?.lang ? <strong>
                    {'['}
                    {field?.config?.lang}
                    {'] '}
                </strong> : null}
                {'Gender'.translate(lang)}
                {isRequired ? <span aria-hidden style={{ color: 'red' }}>*</span> : null}
                {labelInfo && !hasOther ? <div className='info'>
                    <InlineSVG src={infoIcon} />
                    <div className="info-text">{labelInfo}</div>
                </div> : null}
            </legend>
            <div role='presentation' className={`formV2-field-input-gender-wrapper ${classes?.container || ''}`} style={styles?.container}>
                <FormGroup
                    check
                    key={id + 'male'}
                    id={id + 'male' + 'group'}
                    disabled={isDisabled}
                    style={styles?.field}
                    className={classes?.field || ''}
                    onBlur={onBlur}
                    onFocus={onFocus}
                >
                    <Input
                        type='radio'
                        id={id + 'male'}
                        name={name}
                        value='male'
                        checked={value === 'male'}
                        onChange={e => onChange?.(e.target.value)}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        required={isRequired}
                        disabled={isDisabled}
                        invalid={hasError}
                        // valid={valid}
                        {...aria || {}}
                    />
                    <Label
                        check
                        htmlFor={id + 'male'}
                        id={id + 'male' + 'label'}
                    >
                        {'Male'.translate(lang)}
                    </Label>
                </FormGroup>
                <FormGroup
                    check
                    key={id + 'female'}
                    id={id + 'female' + 'group'}
                    disabled={isDisabled}
                    style={styles?.field}
                    className={classes?.field || ''}
                    onBlur={onBlur}
                    onFocus={onFocus}
                >
                    <Input
                        type='radio'
                        id={id + 'female'}
                        name={name}
                        value='female'
                        checked={value === 'female'}
                        onChange={e => onChange?.(e.target.value)}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        required={isRequired}
                        disabled={isDisabled}
                        invalid={hasError}
                        // valid={valid}
                        {...aria || {}}
                    />
                    <Label
                        check
                        htmlFor={id + 'female'}
                        id={id + 'female' + 'label'}
                    >
                        {'Female'.translate(lang)}
                    </Label>
                </FormGroup>
                {hasOther ? <FormGroup
                    check
                    key={id + 'other'}
                    id={id + 'other' + 'group'}
                    disabled={isDisabled}
                    style={styles?.field}
                    className={classes?.field || ''}
                    // onBlur={onBlur}
                    onFocus={onFocus}
                // onClick={() => {
                //     if (['male', 'female', ''].includes(value)) {
                //         onChange?.('other');
                //         setTimeout(() => {
                //             textRef?.current?.focus?.();
                //         }, 100);
                //     }
                // }}
                >
                    <Input
                        type='radio'
                        id={id + 'other'}
                        name={name}
                        value='other'
                        checked={value === 'other' || (value && !['male', 'female'].includes(value))}
                        onChange={e => {
                            onChange?.(e.target.value);
                            setTimeout(() => {
                                textRef?.current?.focus?.();
                            }, 100);
                        }}
                        // onBlur={onBlur}
                        onFocus={onFocus}
                        required={isRequired}
                        disabled={isDisabled}
                        invalid={hasError}
                        // valid={valid}
                        {...aria || {}}
                    />
                    <Label
                        check
                        htmlFor={id + 'other'}
                        id={id + 'other' + 'label'}
                        style={{ display: 'none' }}
                    >
                        {'Other'.translate(lang)}
                    </Label>
                    <input
                        type='text'
                        ref={textRef}
                        value={['male', 'female', 'other', ''].includes(value) ? '' : value}
                        onChange={e => {
                            let val = e.target.value;
                            if (val === '') return onChange?.('other');
                            if (val === 'other') return onChange?.('Other');
                            onChange?.(val)
                        }}
                        placeholder={'Other'.translate(lang)}
                        onBlur={() => { onBlur?.() }}
                        onFocus={() => {
                            if (['male', 'female', ''].includes(value)) onChange?.('other');
                            onFocus?.();
                        }}
                        disabled={(isDisabled) ? true : false}
                        required={['male', 'female', ''].includes(value) ? false : true}
                        className='other-gender-input'
                    />
                </FormGroup> : null}
            </div>
            {_errorMessage ? <FormFeedback>{_errorMessage.translate(lang)}</FormFeedback> : null}
        </>
    )
}

export default GenderV2Field